import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Analytics } from 'components/Analytics/Analytics';
import { AnalyticsHeap } from 'components/AnalyticsHeap/AnalyticsHeap';
import { Chat } from 'components/Chat/Chat';
import { EmbeddedSetup } from 'components/EmbeddedSetup/EmbeddedSetup';
import { ErrorBoundary } from 'components/ErrorBoundry/ErrorBoundry';
import { Routes } from 'components/Routes/Routes';
import { Sift } from 'components/Sift/Sift';
import { AuthUser } from 'containers/AuthUser/AuthUser';
import { TranslationProvider } from 'contexts/TranslationContext/TranslationContext';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { EmbeddedRepository as embedded } from 'repositories/embedded/embedded';
import { store } from 'store/configureStore';

import './EmbeddedEntry';

import './styles/main.scss';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
      retry: 2,
    },
  },
});

const container = document.getElementById('payex-app-root')!;
const root = createRoot(container);

root.render(
  <ErrorBoundary useDefaultFallback>
    <Provider store={store.configure()}>
      <QueryClientProvider client={queryClient}>
        <Analytics />
        <React.StrictMode>
          <AnalyticsHeap />
          <Sift />
          <AuthUser>
            <Router>
              <TranslationProvider>
                <ErrorBoundary>
                  {embedded.isEnabled() && <EmbeddedSetup />}
                  <Routes />
                  {!embedded.isEnabled() && <Chat />}
                </ErrorBoundary>
              </TranslationProvider>
            </Router>
          </AuthUser>
        </React.StrictMode>
      </QueryClientProvider>
    </Provider>
  </ErrorBoundary>,
);
